<template>
  <div class="modal" :class="{ open: visible }" @click.self="handleClose">
    <div class="modal-pay-content" @click.stop>
      <div class="pay-header">
        <span>收银台</span>
        <i class="fas fa-times" @click="handleClose" style="cursor:pointer; color:#999;"></i>
      </div>

      <div class="pay-main-layout">
        <!-- 左侧：支付方式区 -->
        <div class="pay-left">
          <div class="pay-display-card">
            <div style="font-size: 14px; color:#666;">应收金额</div>
            <div class="pay-big-amt">¥{{ displayAmount.toFixed(2) }}</div>
            <div style="margin-top:10px;">
              <span class="tool-chip" :class="{ active: wipeZero }" @click="handleToggleWipe">
                ✂️ 抹零
              </span>
            </div>
          </div>

          <div style="font-weight: bold; margin-bottom:10px;">支付方式</div>
          <div class="pay-types-grid">
            <div class="pay-type-btn" :class="{ active: currentPayMode === 'wechat' }"
              @click="handleSwitchPay('wechat')">
              <i class="fab fa-weixin" style="color:#07C160; font-size:24px; display:block; margin-bottom:5px;"></i>
              微信支付
            </div>
            <div class="pay-type-btn" :class="{ active: currentPayMode === 'alipay' }"
              @click="handleSwitchPay('alipay')">
              <i class="fab fa-alipay" style="color:#1677FF; font-size:24px; display:block; margin-bottom:5px;"></i>
              支付宝
            </div>
            <div class="pay-type-btn" :class="{ active: currentPayMode === 'scan' }" @click="activateScanMode">
              <i class="fas fa-barcode" style="font-size:24px; display:block; margin-bottom:5px;"></i>
              扫码枪
            </div>
            <div class="pay-type-btn" :class="{ active: currentPayMode === 'cash' }" @click="handleSwitchPay('cash')">
              <i class="fas fa-coins" style="color:#F39C12; font-size:24px; display:block; margin-bottom:5px;"></i>
              现金支付
            </div>
          </div>
        </div>

        <!-- 右侧：数字键盘区 (微信、支付宝、现金都显示) -->
        <div class="pay-right-keyboard" :class="{ show: currentPayMode !== 'scan' }">
          <div class="cash-input-row">
            <span>实收 ¥</span>
            <input type="text" class="cash-real-input" v-model="cashInput" readonly placeholder="0.00" />
          </div>

          <div class="numpad-grid">
            <div class="num-key" @click="pressNum('1')">1</div>
            <div class="num-key" @click="pressNum('2')">2</div>
            <div class="num-key" @click="pressNum('3')">3</div>
            <div class="num-key" @click="pressNum('4')">4</div>
            <div class="num-key" @click="pressNum('5')">5</div>
            <div class="num-key" @click="pressNum('6')">6</div>
            <div class="num-key" @click="pressNum('7')">7</div>
            <div class="num-key" @click="pressNum('8')">8</div>
            <div class="num-key" @click="pressNum('9')">9</div>
            <div class="num-key" @click="pressNum('.')">.</div>
            <div class="num-key" @click="pressNum('0')">0</div>
            <div class="num-key action-del" @click="pressNum('back')">
              <i class="fas fa-backspace"></i>
            </div>

            <!-- 找零显示区 (微信、支付宝、现金都显示) -->
            <div style="grid-column: span 3; padding: 10px 0; border-top: 1px dashed #ddd;">
              <div class="change-row">
                <span>找零:</span>
                <span :style="{ color: changeAmount < 0 ? 'red' : '#636E72' }">
                  ¥{{ changeAmount.toFixed(2) }}
                </span>
              </div>
            </div>

            <div class="num-key action-confirm" @click="handleConfirmPay">
              确认收款
            </div>
          </div>
        </div>

        <!-- 扫码覆盖层 -->
        <div class="scan-layer" :class="{ active: currentPayMode === 'scan' }">
          <i class="fas fa-barcode" style="font-size:150px; opacity:0.1;"></i>
          <div class="scan-line"></div>
          <h2 style="margin:20px 0;">请扫描顾客付款码</h2>
          <div style="font-size:1.5rem; color:#2563eb; font-weight:bold;">¥ {{ displayAmount.toFixed(2) }}</div>
          <div style="margin-top: 30px; width: 80%; max-width: 400px;">
            <input
              ref="scanInput"
              v-model="scanCode"
              type="text"
              class="scan-input"
              placeholder="请使用扫码枪扫描顾客付款码"
              @keydown.enter="handleScanInput"
            />
          </div>
          <button @click="cancelScanMode" style="margin-top:30px; padding:10px 30px; border:1px solid #ccc; background:white; cursor:pointer; border-radius: 6px;">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MealPayModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    totalAmount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentPayMode: 'wechat',
      wipeZero: false,
      cashInput: '',
      scanCode: ''
    }
  },
  computed: {
    displayAmount() {
      if (this.wipeZero) {
        return Math.floor(this.totalAmount)
      }
      return this.totalAmount
    },
    changeAmount() {
      if (!this.cashInput) {
        return 0
      }
      const give = parseFloat(this.cashInput) || 0
      return give - this.displayAmount
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetPayState()
      }
    },
    currentPayMode(newVal) {
      if (newVal !== 'cash' && newVal !== 'scan') {
        this.cashInput = ''
      }
      if (newVal === 'scan') {
        this.$nextTick(() => {
          if (this.$refs.scanInput) {
            this.$refs.scanInput.focus()
          }
        })
      }
    }
  },
  methods: {
    resetPayState() {
      this.currentPayMode = 'wechat'
      this.wipeZero = false
      this.cashInput = ''
      this.scanCode = ''
    },
    handleClose() {
      this.$emit('close')
    },
    handleToggleWipe() {
      this.wipeZero = !this.wipeZero
    },
    handleSwitchPay(mode) {
      this.currentPayMode = mode
      if (mode !== 'scan') {
        this.scanCode = ''
      }
    },
    activateScanMode() {
      this.currentPayMode = 'scan'
      this.scanCode = ''
      this.$nextTick(() => {
        if (this.$refs.scanInput) {
          this.$refs.scanInput.focus()
        }
      })
    },
    cancelScanMode() {
      this.currentPayMode = 'cash'
      this.scanCode = ''
    },
    handleScanInput(e) {
      // 扫码枪扫描后会自动触发 Enter 键
      if (e.key === 'Enter' || e.keyCode === 13) {
        if (this.scanCode && this.scanCode.trim().length > 5) {
          this.$emit('scan-pay', this.scanCode.trim())
          this.scanCode = ''
        } else {
          this.$message && this.$message.warning('扫码编号无效，请重新扫描')
          this.scanCode = ''
        }
      }
    },
    pressNum(key) {
      let val = this.cashInput

      if (key === 'back') {
        val = val.slice(0, -1)
      } else if (key === '.') {
        if (!val.includes('.')) {
          val += '.'
        }
      } else {
        // 限制长度和两位小数
        if (val.includes('.') && val.split('.')[1] && val.split('.')[1].length >= 2) {
          return
        }
        val += key
      }

      this.cashInput = val
    },
    handleConfirmPay() {
      if (this.currentPayMode === 'scan') {
        this.$message && this.$message.warning('请使用扫码枪扫描顾客付款码')
        return
      }

      // 微信、支付宝、现金都需要验证金额
      const need = this.displayAmount
      const give = parseFloat(this.cashInput) || 0
      
      if (!give || give < need) {
        this.$message && this.$message.warning('金额不足！')
        return
      }

      this.$emit('pay', {
        method: this.currentPayMode,
        amount: this.displayAmount,
        cashAmount: parseFloat(this.cashInput),
        changeAmount: this.changeAmount
      })
    }
  }
}
</script>

<style scoped>
.modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal.open {
  display: flex;
}

.modal-pay-content {
  background: white;
  width: 800px;
  padding: 25px;
  border-radius: 20px;
  height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pay-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
}

.pay-main-layout {
  display: flex;
  flex: 1;
  gap: 20px;
  overflow: hidden;
  position: relative;
}

.pay-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pay-display-card {
  background: #F7F9FC;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  margin-bottom: 10px;
}

.pay-big-amt {
  font-size: 36px;
  font-weight: 800;
  color: #2D3436;
  margin: 5px 0;
}

.pay-types-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.pay-type-btn {
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: 0.2s;
}

.pay-type-btn.active {
  border-color: #FF6B6B;
  background: #FFF5F5;
  color: #FF6B6B;
  font-weight: bold;
}

.pay-right-keyboard {
  flex: 1.2;
  display: none;
  flex-direction: column;
  background: #fff;
  border-left: 1px solid #eee;
  padding-left: 20px;
}

.pay-right-keyboard.show {
  display: flex;
}

.cash-input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f0f0f0;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 15px;
}

.cash-real-input {
  background: transparent;
  border: none;
  font-size: 24px;
  text-align: right;
  width: 100%;
  outline: none;
  font-weight: bold;
  color: #FF6B6B;
}

.numpad-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  flex: 1;
}

.num-key {
  background: white;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 22px;
  font-weight: bold;
  color: #2D3436;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: 0.1s;
}

.num-key:active {
  background: #eee;
  transform: scale(0.95);
}

.num-key.action-del {
  background: #fff0f0;
  color: #d63031;
  border-color: #ffcccc;
}

.num-key.action-confirm {
  grid-column: span 3;
  background: #2D3436;
  color: white;
  border: none;
  font-size: 18px;
}

.change-row {
  margin-top: 20px;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.tool-chip {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1px solid #ccc;
  font-size: 12px;
  cursor: pointer;
}

.tool-chip.active {
  background: #2D3436;
  color: white;
  border-color: #2D3436;
}

.scan-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(2px);
  z-index: 10;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.scan-layer.active {
  display: flex;
}

.scan-line {
  width: 200px;
  height: 2px;
  background: #ef4444;
  animation: scanning 2s infinite;
  margin-top: -100px;
}

@keyframes scanning {
  0% { transform: translateY(0); opacity: 0; }
  50% { opacity: 1; }
  100% { transform: translateY(200px); opacity: 0; }
}

.scan-input {
  width: 100%;
  padding: 15px;
  font-size: 1.2rem;
  border: 2px solid #ddd;
  border-radius: 8px;
  outline: none;
}

.scan-input:focus {
  border-color: #2563eb;
}
</style>
